exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help__actions[data-v-185aa80a]{list-style:none;padding-inline-start:0;margin:0}.help__actions li a[data-v-185aa80a]:last-child{padding:10px 0;margin-bottom:0;font-size:var(--font-large)}.help__action[data-v-185aa80a]{padding:0;font-size:var(--font-normal);font-weight:var(--font-weight-lighter);display:flex;flex-direction:row;align-items:center;margin-bottom:15px;color:var(--black)}.help__action__icon[data-v-185aa80a]{height:20px;margin-right:5px;fill:var(--black)}.help__action svg[data-v-185aa80a]{margin-right:15px}", ""]);

// exports
